export const NAME = 'ui' as const;

export const CHANGE_ODD_FORMAT = `ui/CHANGE_ODD_FORMAT` as const;
export const CHANGE_SIDEBAR_VIEW = `ui/CHANGE_SIDEBAR_VIEW` as const;
export const CHANGE_FAVORITE_COUNT = `ui/CHANGE_FAVORITE_COUNT` as const;
export const CHANGE_ODDS_STATISTIC = `ui/CHANGE_ODDS_STATISTIC` as const;

export const ENABLE_ODD_HISTORY = `ui/ENABLE_ODD_HISTORY` as const;
export const DISABLE_ODD_HISTORY = `ui/DISABLE_ODD_HISTORY` as const;

export const OPEN_SIDEBAR = `ui/OPEN_SIDEBAR` as const;
export const CLOSE_SIDEBAR = `ui/CLOSE_SIDEBAR` as const;

export const OPEN_MOBILE_TOP_MATCHES = `ui/OPEN_MOBILE_TOP_MATCHES` as const;
export const CLOSE_MOBILE_TOP_MATCHES = `ui/CLOSE_MOBILE_TOP_MATCHES` as const;

export const OPEN_FILTER = `ui/OPEN_FILTER` as const;
export const CLOSE_FILTER = `ui/CLOSE_FILTER` as const;

export const SET_ACTIVE_SPORT_TYPE = 'ui/SET_ACTIVE_SPORT_TYPE' as const;

export enum UISettingKey {
    ODD_FORMAT = 'oddFormat',
    SHOW_ODDS_STATISTIC = 'showOddsStatistics',
    ODD_STATISTIC_VIEW = 'oddStatisticView',
    SHOW_ODD_HISTORY = 'showOddHistory',
}

export class KeyPathToReducerProp implements Record<UISettingKey, unknown> {
    [UISettingKey.ODD_FORMAT] = 'oddFormat' as const;
    [UISettingKey.SHOW_ODDS_STATISTIC] = 'oddsStatistic.show' as const;
    [UISettingKey.ODD_STATISTIC_VIEW] = 'oddsStatistic.statisticView' as const;
    [UISettingKey.SHOW_ODD_HISTORY] = 'isOddHistoryEnabled' as const;
}

export const UI_GAMBLER_SETTINGS = {
    [NAME]: { ...new KeyPathToReducerProp() },
};
